import { formatCurrency } from '../../lib/wallet/utils';

const CurrencyDisplay = ({ amount, currencyCode, currencySymbol, className = '' }) => {
    return (
        <span className={`currency-display fw-semibold ${className}`}>
            {formatCurrency(amount, currencyCode, currencySymbol)}
        </span>
    );
};

export default CurrencyDisplay;
